import { EAccountPlansType } from "../../Enum/EAccountPlansType"
import { AdminPlanPeriod } from "./AdminPlanPeriod"

export class AdminPlan {
  id: number

  eAccountPlansType: EAccountPlansType

  name: string

  description?: string

  isActive: boolean

  displayOrder: number

  periods: AdminPlanPeriod[]

  constructor(data: Partial<AdminPlan> = {}) {
    this.id = data.id ?? 0

    this.eAccountPlansType = data.eAccountPlansType ?? EAccountPlansType.None

    this.name = data.name ?? ""

    this.description = data.description

    this.isActive = data.isActive ?? false

    this.displayOrder = data.displayOrder ?? 0

    this.periods = data.periods?.map((item) => new AdminPlanPeriod(item)) ?? []
  }
}
